import React from "react";
import type { SVGProps } from "react";

const SocialInsightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      stroke="#383838"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 13C17 15.038 14.761 17.5 12 17.5C9.239 17.5 7 15.038 7 13C7 14.444 17 14.444 17 13Z"
      stroke="#383838"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 6.8125L9.618 8.0655L11 8.2655L10 9.2405L10.236 10.6175L9 9.9675L7.764 10.6175L8 9.2405L7 8.2655L8.382 8.0655L9 6.8125Z"
      fill="#383838"
    />
    <path
      d="M15 6.8125L15.618 8.0655L17 8.2655L16 9.2405L16.236 10.6175L15 9.9675L13.764 10.6175L14 9.2405L13 8.2655L14.382 8.0655L15 6.8125Z"
      fill="#383838"
    />
    <path
      d="M9 6.8125L9.618 8.0655L11 8.2655L10 9.2405L10.236 10.6175L9 9.9675L7.764 10.6175L8 9.2405L7 8.2655L8.382 8.0655L9 6.8125Z"
      stroke="#383838"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 6.8125L15.618 8.0655L17 8.2655L16 9.2405L16.236 10.6175L15 9.9675L13.764 10.6175L14 9.2405L13 8.2655L14.382 8.0655L15 6.8125Z"
      stroke="#383838"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SocialInsightIcon;

